// extracted by mini-css-extract-plugin
export default {"DragAndDrop_children":"CreateProfile_DragAndDrop_children__TQVGr","status_check":"CreateProfile_status_check__lLmvO"};